/* eslint no-console:0 */
/*
 * this file is automatically compiled by Webpack, along with any other files
 * present in this directory. You're encouraged to place your actual application logic in
 * a relevant structure within app/javascript and only use these pack files to reference
 * that code so it'll be compiled.
 *
 * To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
 * layout file, like app/views/layouts/application.html.erb
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'src/store';
import Routes from 'src/routes';
import cleverTap from '../src/services/cleverTap';
import { ActionCableProvider } from 'react-actioncable-provider'

cleverTap.initialize();

// when path for websocket is '/cable', we can skip url prop.
class Application extends React.Component {

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.log(error);
    cleverTap.event('ERROR_OCCURED', { Error: error.message,
Stack: error.stacktrace });
  }

  render() {
    return <ActionCableProvider> <Routes/> </ActionCableProvider>
  }
}

ReactDOM.render(
  <Provider store={store}>
    <Application />
  </Provider>,
  document.getElementById('app')
);
